import './index.scss';

var hostname = location.hostname;
var domain = 'shop.hachettebookgroup.com';
var storefrontAccessToken = 'fdf7a12aac6fc02a21b014e8b569ad8a';
var freeShippingAmt = 45.00;
var productId = 7655547470002;
if( hostname === 'hbg-develop.go-vip.co' ){
  domain = 'hbgusadev.myshopify.com/';
  storefrontAccessToken = '4865c5a95d3390ff3efbee487c953e39';
  productId = 8382492770464;
} 
var addToCartIsbns = Object.entries(window).filter(([key]) => key.startsWith('addToCart_')); // eslint-disable-line max-len
var addToCartButton = {};
var buttonText = '';
if(addToCartIsbns.length == 0) {
  ShopifyBuyInit(productId, '000000000000', freeShippingAmt);
  addToCartButton = {
      "font-size": "13px",
      "padding-top": "14.5px",
      "padding-bottom": "14.5px",
      "border-radius": "0px",
      "padding-left": "0px",
      "padding-right": "0px"
  };
  buttonText = '';
} else {
  addToCartButton = {
    "font-weight": "bold",
    "font-size": "16px",
    "padding-top": "16px",
    "padding-bottom": "16px",
    ":hover": {
      "background-color": "#cb2f21"
    },
    "background-color": "#e13425",
    ":focus": {
      "background-color": "#cb2f21"
    }
  };  
  buttonText = 'Add to Cart';
  launchCartButtonOnLoad();
}
// if cartadd is true in url params, launch cart directly on load.
function launchCartButtonOnLoad() {
  addToCartIsbns.forEach(([k, title]) => { // eslint-disable-line no-unused-vars, consistent-return
    var hbgEndpoint = 'https://shopifyapi.hbgusa.com/hbg-shopify-api/api/product/info/Shopify-HbgUsa/'+title.isbn;;
    if( hostname === 'hbg-develop.go-vip.co' ){
      hbgEndpoint = 'https://shopifyapistg.hbgusa.com/hbg-shopify-api/api/product/info/Shopify-HbgUsa/'+title.isbn;
    } 
    return fetch(hbgEndpoint)
      .then((response) => {
        if (response.ok) {
          return response.json();
        }
        return false;
      })
      .then((response) => {
        if (response &&  ( response.inventoryLevel > 0 || 'Y' == response.preorder) && response.show) {
          var productId = response.productId;
          var isbn = response.isbn;
          if('Y' == response.preorder){
            buttonText = 'Preorder';
          }
          ShopifyBuyInit(productId, isbn, freeShippingAmt);
        }
      })
      .catch((err) => {
        if (console && console.error) { // eslint-disable-line no-console
          console.error(err); // eslint-disable-line no-console
        }
      });
    });

  return false;
}

function ShopifyBuyInit(productId, isbn, freeShippingAmt) {
  var client = ShopifyBuy.buildClient({
    domain: domain,
    storefrontAccessToken: storefrontAccessToken,
  });
  ShopifyBuy.UI.onReady(client).then(function (ui) {
    ui.createComponent('product', {
      id: productId,
      node: document.getElementById('product-component-add-to-cart'+isbn),
      moneyFormat: '%24%7B%7Bamount%7D%7D',
      options: {
        "product": {
          "styles": {
            "product": {
              "@media (min-width: 601px)": {
                "max-width": "calc(25% - 20px)",
                "margin-left": "20px",
                "margin-bottom": "50px"
              }
            },
            "button": addToCartButton,
            "quantityInput": {
              "font-size": "16px",
              "padding-top": "16px",
              "padding-bottom": "16px"
            }
          },
          "contents": {
            "img": false,
            "title": false,
            "price": false
          },
          "text": {
            "button": buttonText
          }
        },
        "productSet": {
          "styles": {
            "products": {
              "@media (min-width: 601px)": {
                "margin-left": "-20px"
              }
            }
          }
        },
        "modalProduct": {
          "contents": {
            "img": false,
            "imgWithCarousel": true,
            "button": false,
            "buttonWithQuantity": true
          },
          "styles": {
            "product": {
              "@media (min-width: 601px)": {
                "max-width": "100%",
                "margin-left": "0px",
                "margin-bottom": "0px"
              }
            },
            "button": {
              "font-weight": "bold",
              "font-size": "16px",
              "padding-top": "16px",
              "padding-bottom": "16px",
              ":hover": {
                "background-color": "#cb2f21"
              },
              "background-color": "#e13425",
              ":focus": {
                "background-color": "#cb2f21"
              }
            },
            "quantityInput": {
              "font-size": "16px",
              "padding-top": "16px",
              "padding-bottom": "16px"
            }
          },
          "text": {
            "button": buttonText
          }
        },
        "option": {},
        "cart": {
          "iframe": false,
          "events": {
            'beforeRender': function (component) {},
            'afterRender': function (component) {
              let currentSubtotalText = jQuery('.shopify-buy__cart .shopify-buy__cart__subtotal__price').text();
              let currentSubtotalNumber = Number(currentSubtotalText.replace(/[^0-9.-]+/g,""));
              let freeShippingRemainingAmt = freeShippingAmt - currentSubtotalNumber;
              freeShippingRemainingAmt = freeShippingRemainingAmt.toFixed(2);
              let freeShippingMsg = '';
              if(freeShippingRemainingAmt > 0.00){
                freeShippingMsg = 'You are $'+freeShippingRemainingAmt+' away from free shipping!';
              } else {
                freeShippingMsg = "You've got free shipping!";
              }
              jQuery('.shopify-buy__cart__title')
                .after('<div id="freeShippingMsg">'+freeShippingMsg+'</div>');
            }
          },
          "styles": {
            "button": {
              "font-weight": "bold",
              "font-size": "16px",
              "padding-top": "16px",
              "padding-bottom": "16px",
              ":hover": {
                "background-color": "#cb2f21"
              },
              "background-color": "#e13425",
              ":focus": {
                "background-color": "#cb2f21"
              }
            }
          },
          "text": {
            "title": "Shopping Cart",
            "total": "Subtotal",
            "button": "Checkout",
            "noteDescription": "Add an optional Gift Message (250 character limit)"
          },
          "popup": false,
          "contents": {
            "note": true
          },
        },
        "toggle": {
          "styles": {
            "toggle": {
              "font-weight": "bold",
              "background-color": "#e13425",
              ":hover": {
                "background-color": "#cb2f21"
              },
              ":focus": {
                "background-color": "#cb2f21"
              }
            },
            "count": {
              "font-size": "16px"
            }
          }
        }}
    });
  });
}
